import { BalllotReviewProps } from "../types";
import { sortResult } from "../../pages/election/util";
import { BasicTextInputValue } from "./basic-text-typedef";
import { Typography } from "@mui/material";

export const BasicTextReview = ({ response, question }: BalllotReviewProps<BasicTextInputValue>) => {
    const { text_input } = response;
    return (
        <Typography variant="subtitle1" sx={{
            color: "#333",
            background: "#F3F3F3",
            px: 2,
            py: 1.5,
            fontStyle: "italic"
        }}>{text_input}</Typography>
    )
}